import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { withStyles, Grid } from "@material-ui/core";

import { BasePage } from "altus-ui-components";

import {
  clearView,
  viewOnLoad,
  closeWebSocket,
} from "features/planner/planner.actions";

import {
  ACTIONS,
  GROUP_TYPES,
  VIEW_SIDE_PANEL_ID,
  SEARCH_SIDE_PANEL_ID,
} from "features/planner/planner.constants";

import { getSummarizedDataStatesFromState } from "app/app.selectors";
import { getViewFromState } from "features/planner/planner.selectors";
import SimplePanelContainer from "app/components/SimplePanelContainer";
import ViewSidePanel from "features/planner/components/View/ViewSidePanel";
import GroupsContainer from "features/planner/components/View/GroupsContainer";
import SearchSidePanel from "features/planner/components/Search/SearchSidePanel";

class View extends PureComponent {
  componentDidMount() {
    const { viewId, dispatchOnLoad } = this.props;

    dispatchOnLoad(viewId);
  }

  componentWillUnmount() {
    const { dispatchClearView, dispatchCloseWebSocket, viewId } = this.props;

    dispatchClearView();
    dispatchCloseWebSocket(viewId);
  }

  render() {
    const {
      view,
      viewId,
      classes,
      dataState,
      isEditMode,
      saveViewGroupOrder,
      deleteViewGroupColumn,
    } = this.props;

    if (!view) return null;

    return (
      <BasePage
        dataState={dataState}
        classes={{
          root: classes.basePageRoot,
          children: classes.basePageChildren,
        }}
      >
        <Grid
          xs
          item
          container
          wrap="nowrap"
          justifyContent="space-between"
          className={classes.root}
        >
          {[GROUP_TYPES.LOCATION_GROUP, GROUP_TYPES.PLANNING_GROUP].map(
            groupType => (
              <GroupsContainer
                key={groupType}
                viewId={viewId}
                type={groupType}
                isEditMode={isEditMode}
                saveViewGroupOrder={saveViewGroupOrder}
                deleteViewGroupColumn={deleteViewGroupColumn}
                columnCount={view.getIn(["columnCount", groupType.toString()])}
              />
            ),
          )}
          {!isEditMode && (
            <>
              <SimplePanelContainer panelId={SEARCH_SIDE_PANEL_ID}>
                <SearchSidePanel viewId={viewId} />
              </SimplePanelContainer>
              <SimplePanelContainer panelId={VIEW_SIDE_PANEL_ID}>
                <ViewSidePanel viewId={viewId} />
              </SimplePanelContainer>
            </>
          )}
        </Grid>
      </BasePage>
    );
  }
}

const styles = theme => ({
  root: {
    overflow: "hidden",
  },
  basePageRoot: {
    background: theme.altus.background.view,
  },
  basePageChildren: {
    padding: 0,
  },
});

export default compose(
  connect(
    (state, { viewId }) => ({
      view: getViewFromState(state, viewId),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.SEARCH_VIEW,
        ACTIONS.GET_VIEW,
        ACTIONS.GET_CREWS,
        ACTIONS.CREATE_CARD_MOVE,
        ACTIONS.GET_QUALIFICATIONS,
        ACTIONS.INITIALIZE_EDIT_COMPANY,
        ACTIONS.UPDATE_VIEW_GROUPS_ORDER,
        ACTIONS.GET_REPLACEABLE_EMPLOYEES,
        ACTIONS.GET_CARD_MISSING_COMPETENCY_STATUS_ITEMS_FOR_GROUP,
      ),
    }),
    {
      dispatchOnLoad: viewOnLoad,
      dispatchClearView: clearView,
      dispatchCloseWebSocket: closeWebSocket,
    },
  ),
  withStyles(styles),
)(View);
